import MuiDialogContent from '@mui/material/DialogContent';
import { withStyles } from '@mui/styles';

;

const AddGpcDialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(3),
  },
}))(MuiDialogContent);

export default AddGpcDialogContent;
